"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const KeyValueColumnWithLinks_1 = tslib_1.__importDefault(require("./KeyValueColumnWithLinks"));
class SimpleKeyValueColumn extends KeyValueColumnWithLinks_1.default {
    constructor(args) {
        super({
            ...args,
            moduleContext: null
        });
        this.element.classList.toggle("key-value-column-striped", !!args.striped);
    }
    async setData(data) {
        await super.setData(data);
    }
}
exports.default = SimpleKeyValueColumn;
//# sourceMappingURL=SimpleKeyValueColumn.js.map